import React from 'react';
import Login from 'src/ui/features/Login/presentational/LoginPres';
import ForgotPassword from 'src/ui/features/Login/presentational/ForgotPasswordPres';
import TwoFactor from 'src/ui/features/Login/presentational/TwoFactorPres';
import ResetPasswordPres from 'src/ui/features/Login/presentational/ResetPasswordPres';
import { FPASSPAGE, TFAPAGE, RPASSPAGE } from '../state/constants';

const getComponent = loginPage => {
  switch (loginPage) {
    case FPASSPAGE:
      return ForgotPassword;
    case TFAPAGE:
      return TwoFactor;
    case RPASSPAGE:
      return ResetPasswordPres;
    default:
      return Login;
  }
};

export default props => {
  const { loginPage, ...otherProps } = props;
  const Component = getComponent(loginPage);
  return <Component {...otherProps} />;
};



// WEBPACK FOOTER //
// ./src/ui/features/Login/presentational/index.js